import { NotificationDto } from '@interfaces/models';
import { ColumnDef } from '@ui/components';

import { NotificationElement } from './notification-element/notification-element';

export const getNotificationsColumns = (
  onRemoveNotification: (notification: NotificationDto) => void,
  onMarkAsRead: (notification: NotificationDto) => void,
): ColumnDef<NotificationDto>[] => [
  {
    id: 'default',
    cell: ({ row }) => (
      <NotificationElement
        {...row.original}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        onRemove={() => onRemoveNotification(row.original)}
        onMarkAsRead={() => onMarkAsRead(row.original)}
        checked={row.getIsSelected()}
      />
    ),
  },
];
